import { render, staticRenderFns } from "./ResetPasswordPage.vue?vue&type=template&id=28dd4e81&scoped=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=js"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordPage.vue?vue&type=style&index=0&id=28dd4e81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd4e81",
  null
  
)

export default component.exports